import axios from 'axios'
import Vue from 'vue'
import store from '@/state/store.js'
import { Modal } from 'ant-design-vue';
import i18n from "@/i18n"
import router from '@/router'

// const apiBaseUrl = process.env.NODE_ENV !== 'production' ? '/api' : process.env.VUE_APP_API_BASE_URL
const apiBaseUrl = process.env.NODE_ENV !== 'production' ? '/api' : ''
let hasShownUnauthorizedModal = false;
const service = axios.create({
    baseURL: apiBaseUrl, // API base URL
    timeout: 90000, // 请求超时时间
    responseType: 'json' // 服务器响应的数据类型，默认为 json
});


//添加请求拦截器
service.interceptors.request.use(
    (config) => {
        config.headers['Access-Control-Allow-Origin'] = '*'
        config.headers['lang'] = localStorage.getItem('lang')
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
        // userType 1：员工，2：用户
        const userType = process.env.VUE_APP_ADDRESS === 'pro' ? 1 : 2;
        config.headers['userType'] = userType;
        const token = localStorage.getItem('Token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config
    },
    //捕捉到错误的处理 如果在请求发送过程中遇到错误，拦截器会捕捉到这个错误并返回一个拒绝promis对象同时携带错误信息
    (error) => {
        return Promise.reject(new Error(error))
    })
//添加响应拦截器
service.interceptors.response.use(
    (res) => {
        //
        // Modal.error({
        //     title: i18n.global.t('Landing failure.'),//'登录已过期',
        //     content: i18n.global.t('Landing failure.') + ',' + i18n.global.t('Return to login page'),//'很抱歉，登录已过期，请重新登录',
        //     okText: i18n.global.t('Return to login page'),
        //     onOk() {
        //         store.dispatch('changeLogout').then(() => {
        //             router.push({ path: '/login' })
        //         })
        //     }
        // });
        const status = res.data.code || 200
        const msg = res.data.msg;
        //参数错误 前端错误
        if (status === 200) return res.data
        else {
            console.log(111, res.data)
            return res.data
        }
    },
    (error) => {
        let { message } = error;
        if (message.includes("Request failed with status code")) {
            let code = message.substr(message.length - 3)
            if (code == 401 && !hasShownUnauthorizedModal) {
                hasShownUnauthorizedModal = true;
                Modal.error({
                    title: i18n.global.t('Landing failure.'),//'登录已过期',
                    content: i18n.global.t('Landing failure.') + ',' + i18n.global.t('Return to login page'),//'很抱歉，登录已过期，请重新登录',
                    okText: i18n.global.t('Return to login page'),
                    onOk() {
                        store.dispatch('changeLogout').then(() => {
                            router.push({ path: '/login' })
                        })
                    }
                });
                return
            }
        }

        // for debug
        return Promise.reject(new Error(error.message))
    }
)

export default service
